// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1vHB6","left":"StickyBox_left__3F8yi","right":"StickyBox_right__2QUt0"};